import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Send, ExternalLink, ArrowDown, Building2 } from 'lucide-react';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden px-4 pt-20 pb-10" data-id="element-103">
      {/* Decorative Background Orbs */}
      <div className="bg-orb w-96 h-96 bg-pink-primary top-[-10%] left-[-10%]" data-id="element-104"></div>
      <div className="bg-orb w-[500px] h-[500px] bg-pink-primary bottom-[-20%] right-[-10%] opacity-10" data-id="element-105"></div>

      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20 pointer-events-none" data-id="element-106"></div>

      <motion.div className="relative z-10 flex flex-col items-center text-center max-w-4xl mx-auto" variants={containerVariants} initial="hidden" animate="visible" data-id="element-107">
        <motion.img src="https://cdn.magicpatterns.com/uploads/9kDESAf73B4fWLx8MEhe2j/escort.geylang666-20251016092455065674.png" alt="Geylang777 Logo" className="h-24 md:h-32 mb-8 object-contain drop-shadow-[0_0_15px_rgba(233,30,140,0.5)]" variants={itemVariants} data-id="element-108" />

        <motion.div variants={itemVariants} className="mb-6" data-id="element-109">
          <h1 className="text-4xl md:text-6xl font-black text-white mb-2 tracking-wider neon-glow" data-id="element-110">
            芽笼777
          </h1>
          <h2 className="text-xl md:text-3xl font-bold text-pink-primary mb-4" data-id="element-111">
            新加坡顶级伴游服务平台
          </h2>
          <p className="text-lg md:text-xl text-gray-300 font-light tracking-wide" data-id="element-112">
            Singapore's Premier Escort Companion Platform
          </p>
        </motion.div>

        <motion.div variants={itemVariants} className="mb-12" data-id="element-113">
          <p className="text-sm md:text-base text-gray-400 uppercase tracking-[0.2em] border-y border-pink-primary/30 py-2 px-4 inline-block" data-id="element-114">
            为您甄选最优质的伴游体验 | Curated Premium Companion Experiences
          </p>
        </motion.div>

        <motion.div variants={itemVariants} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-115">
          <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="neon-btn pulse-glow flex items-center justify-center gap-2 px-8 py-4 rounded-full text-white font-bold text-lg w-full sm:w-auto" data-id="element-116">
            <Send size={20} data-id="element-117" />
            加入Telegram频道
          </a>

          <a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 px-8 py-4 rounded-full text-white font-bold text-lg border-2 border-pink-primary hover:bg-pink-primary/10 transition-colors w-full sm:w-auto" data-id="element-118">
            <Building2 size={20} data-id="element-119" />
            新加坡春风阁
          </a>
        </motion.div>
      </motion.div>

      <motion.div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-pink-primary/70" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} data-id="element-120">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-121">
          <ArrowDown size={32} data-id="element-122" />
        </motion.div>
      </motion.div>
    </section>;
}